module.exports = __webpack_public_path__ + "static/media/prev-control-carousel-active.bc96bc4b.svg";